import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { references } from './references';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  constructor() {}

  // Salvar dados no sessionStorage
  save(key: string, data: any): void {
    try {
      const serializedData = JSON.stringify(data);
      sessionStorage.setItem(key, serializedData);
    } catch (e) {
      console.error('Error saving to sessionStorage', e);
    }
  }

  // Carregar dados do sessionStorage
  load(key: string): any {
    if (typeof sessionStorage === 'undefined') {
      console.warn('sessionStorage is not available');
      return null;
    }
    try {
      const serializedData = sessionStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (e) {
      console.error('Error loading from sessionStorage', e);
      return null;
    }
  }

  // Remover dados do sessionStorage
  remove(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      console.error('Error removing from sessionStorage', e);
    }
  }

  // Limpar todo o sessionStorage
  clear(): void {
    try {
      sessionStorage.clear();
    } catch (e) {
      console.error('Error clearing sessionStorage', e);
    }
  }

  // Função para decodificar token e extrair dados
  decodeToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch (e) {
      console.error('Error decoding token', e);
      return null;
    }
  }

  // Função para obter dados específicos do token armazenado
  getInfoFromToken(): any {
    const token = this.load(references._STORAGE_TOKEN);
    if (!token) return null;
    return this.decodeToken(token);
  }

  hasCancelReservationPermission(): boolean {
    const jwtPayload = this.getInfoFromToken();
    console.log('jwtPayload', jwtPayload);

    if (!jwtPayload || !jwtPayload.role) {
      return false;
    }

    const userRoles = jwtPayload.role;
    const rolesSemCancelamento = ['ManagerReserva'];


    if (typeof userRoles === 'string') {
      return !rolesSemCancelamento.includes(userRoles);
    }

    if (Array.isArray(userRoles)) {
      return userRoles.some((role) => !rolesSemCancelamento.includes(role));
    }

    return false;
  }
}
